module.exports = __webpack_public_path__ + "img/singapore-featured-image-200x132.a50f2c16.jpg";